import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { GraduationCap, ArrowRight } from "lucide-react";

/**
 * NoEnrolledCourseBanner — shown on the student dashboard when a student
 * has not yet enrolled in any course (brand-new account, just signed up).
 *
 * Replaces the limited-access + profile-completion warnings, which only make
 * sense once the student has actually picked a course.
 */
export default function NoEnrolledCourseBanner() {
  return (
    <Card
      className="p-4 sm:p-5 border-2 border-blue-300 dark:border-blue-700 bg-blue-50/80 dark:bg-blue-900/30"
      data-testid="no-enrolled-course-banner"
    >
      <div className="flex items-start gap-3 sm:gap-4">
        <div className="h-10 w-10 rounded-lg grid place-items-center shrink-0 bg-blue-100 dark:bg-blue-800/50 text-blue-700 dark:text-blue-300">
          <GraduationCap className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-blue-900 dark:text-blue-100">
            You are not enrolled in any course yet.
          </div>
          <p className="text-sm text-blue-800 dark:text-blue-200 mt-1">
            Please choose a course to start learning. You'll get instant free-trial access — no payment needed up front.
          </p>
          <div className="mt-3">
            <Button asChild size="sm" className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="no-course-browse-btn">
              <Link to="/student/enrollments?tab=available">
                Browse Courses <ArrowRight className="w-4 h-4 ml-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
}
